(function(){
    'use strict';

    var $smpIndex = $(".smp-index");

    if($smpIndex.length){
        var html = "<ul class='smp-index__list'>";

        $('.page-content h2').each(function(i) {
            if(!$(this).parents('.accordion').length) {
                html += "<li><a href='#heading-" + i + "'><span>" + $(this).text() + "</span></a></li>";

                $(this).html('<a name="heading-' + i + '">' + $(this).text() + '</a>');
            }
        });

        html += "</ul";

        $(".smp-index").append(html);
    }
}());
